import { render } from "./AskusNew.vue?vue&type=template&id=382afcfe&scoped=true"
import script from "./AskusNew.vue?vue&type=script&lang=js"
export * from "./AskusNew.vue?vue&type=script&lang=js"

import "./AskusNew.vue?vue&type=style&index=0&id=382afcfe&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382afcfe"]])

export default __exports__